(function() {
  'use strict';

  /**
   * Resizes + compresses an image File to a JPEG data URL.
   * Dramatically reduces cart payload size so add/change/update requests stay fast.
   */
  function compressImageFile(file, maxDimension = 1200, quality = 0.8) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = reject;
      reader.onload = () => {
        const img = new Image();
        img.onerror = reject;
        img.onload = () => {
          let { width, height } = img;
          if (width > maxDimension || height > maxDimension) {
            const scale = maxDimension / Math.max(width, height);
            width = Math.round(width * scale);
            height = Math.round(height * scale);
          }
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);
          resolve(canvas.toDataURL('image/jpeg', quality));
        };
        img.src = reader.result;
      };
      reader.readAsDataURL(file);
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    const section = document.querySelector('.lp-pdp-engraved-locket');
    if (!section) return;

    /** Maps variant id -> featured media id (from Liquid); used to match gallery slides and reuse data-main-src URLs. */
    let featuredMediaMap = {};
    const featuredMediaEl = section.querySelector('#lp-variant-featured-media');
    if (featuredMediaEl) {
      try {
        featuredMediaMap = JSON.parse(featuredMediaEl.textContent);
      } catch (e) {
        featuredMediaMap = {};
      }
    }

    // ============ Lightbox Variables ============
    let allImages = [];
    let currentImageIndex = 0;

    // ============ Main Image Update Function ============
    const mainImage = section.querySelector('#lp-main-img');

    /**
     * Resolves the main image URL to match #lp-main-img width (1000w) when the slide exists in the gallery,
     * so swaps reuse the same URL we prefetch and avoid an extra CDN fetch for a different resize.
     */
    function getMainImageUrlForVariant(variant) {
      if (!variant) {
        return null;
      }

      let mediaId =
        featuredMediaMap[variant.id] != null ? featuredMediaMap[variant.id] : null;
      if (mediaId == null && variant.featured_media && variant.featured_media.id) {
        mediaId = variant.featured_media.id;
      }

      if (mediaId != null) {
        const slideImg = section.querySelector(
          '.lp-pdp__swiper-slide img[data-media-id="' + mediaId + '"]'
        );
        if (slideImg) {
          const mainSrc = slideImg.getAttribute('data-main-src');
          if (mainSrc) {
            return mainSrc;
          }
        }
      }

      if (variant.featured_image && variant.featured_image.src) {
        return variant.featured_image.src;
      }
      if (
        variant.featured_media &&
        variant.featured_media.preview_image &&
        variant.featured_media.preview_image.src
      ) {
        return variant.featured_media.preview_image.src;
      }
      return null;
    }

    /** Preload main-size images for every gallery slide so the first swatch change hits cache after refresh. */
    function prefetchMainImagesForSwatches() {
      const seen = new Set();
      const slideImages = section.querySelectorAll('.lp-pdp__swiper-slide img[data-main-src]');
      for (const img of slideImages) {
        const url = img.getAttribute('data-main-src');
        if (url && !seen.has(url)) {
          seen.add(url);
          const pre = new Image();
          pre.src = url;
        }
      }
    }

    function updateMainImage(imageSrc) {
      if (mainImage && imageSrc) {
        mainImage.src = imageSrc;
      }
    }

    // ============ Initialize All Images ============
    function initializeAllImages() {
      // We only collect from swiper to avoid duplicates from thumbnail grid,
      // as they contain identical images but at different resolution sizes.
      const swiperImages = Array.from(section.querySelectorAll('.lp-pdp__swiper-slide img'));
      
      allImages = [];
      
      swiperImages.forEach(img => {
        if (img.src) {
          allImages.push(img.src);
        }
      });

      // If no images found, try to get from featured image
      if (allImages.length === 0 && mainImage) {
        allImages.push(mainImage.src);
      }
    }

    // ============ Lightbox Functions ============
    const lightbox = section.querySelector('#lp-lightbox');
    const lightboxTrack = section.querySelector('#lp-lightbox-track');
    const lightboxClose = section.querySelector('#lp-lightbox-close');
    const lightboxPrev = section.querySelector('#lp-lightbox-prev');
    const lightboxNext = section.querySelector('#lp-lightbox-next');
    const lightboxOverlay = section.querySelector('.lp-pdp__lightbox-overlay');
    const lightboxDotsContainer = section.querySelector('#lp-lightbox-dots');

    function createLightboxDots() {
      if (!lightboxDotsContainer) return;
      
      lightboxDotsContainer.innerHTML = '';
      allImages.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.className = 'lp-pdp__lightbox-dot';
        if (index === currentImageIndex) {
          dot.classList.add('lp-pdp__lightbox-dot--active');
        }
        dot.addEventListener('click', (e) => {
          e.stopPropagation();
          currentImageIndex = index;
          if (lightboxTrack) {
            lightboxTrack.style.transition = 'transform 0.3s ease-out';
            lightboxTrack.style.transform = `translate3d(-${currentImageIndex * 100}%, 0, 0)`;
          }
          updateLightboxControls();
        });
        lightboxDotsContainer.appendChild(dot);
      });
    }

    function createLightboxImages() {
      if (!lightboxTrack) return;
      lightboxTrack.innerHTML = '';
      allImages.forEach((src) => {
        const img = document.createElement('img');
        img.className = 'lp-pdp__lightbox-image';
        img.src = src;
        img.alt = 'Product image';
        img.style.flex = '0 0 100%';
        img.style.width = '100%';
        img.style.height = '100%';
        img.style.objectFit = 'contain';
        img.draggable = false;
        lightboxTrack.appendChild(img);
      });
    }

    function openLightboxAtIndex(index) {
      if (index < 0 || index >= allImages.length) return;
      
      currentImageIndex = index;
      createLightboxImages();
      
      if (lightboxTrack) {
        lightboxTrack.style.transition = 'none';
        lightboxTrack.style.transform = `translate3d(-${currentImageIndex * 100}%, 0, 0)`;
      }

      lightbox.classList.add('lp-pdp__lightbox--active');
      updateLightboxControls();
      createLightboxDots();
    }

    function closeLightbox() {
      lightbox.classList.remove('lp-pdp__lightbox--active');
    }

    function updateLightboxControls() {
      // Disable/Enable prev arrow
      if (lightboxPrev) {
        lightboxPrev.disabled = currentImageIndex === 0;
      }
      
      // Disable/Enable next arrow
      if (lightboxNext) {
        lightboxNext.disabled = currentImageIndex === allImages.length - 1;
      }

      // Update active dot
      const dots = lightboxDotsContainer.querySelectorAll('.lp-pdp__lightbox-dot');
      dots.forEach((dot, index) => {
        if (index === currentImageIndex) {
          dot.classList.add('lp-pdp__lightbox-dot--active');
        } else {
          dot.classList.remove('lp-pdp__lightbox-dot--active');
        }
      });
    }

    function nextImage() {
      if (currentImageIndex < allImages.length - 1) {
        currentImageIndex++;
        if (lightboxTrack) {
          lightboxTrack.style.transition = 'transform 0.3s ease-out';
          lightboxTrack.style.transform = `translate3d(-${currentImageIndex * 100}%, 0, 0)`;
        }
        updateLightboxControls();
      }
    }

    function prevImage() {
      if (currentImageIndex > 0) {
        currentImageIndex--;
        if (lightboxTrack) {
          lightboxTrack.style.transition = 'transform 0.3s ease-out';
          lightboxTrack.style.transform = `translate3d(-${currentImageIndex * 100}%, 0, 0)`;
        }
        updateLightboxControls();
      }
    }

    // Lightbox event listeners
    if (lightboxClose) {
      lightboxClose.addEventListener('click', (e) => {
        e.stopPropagation();
        closeLightbox();
      });
    }

    // Close when clicking on overlay or any empty space in lightbox
    if (lightbox) {
      lightbox.addEventListener('click', (e) => {
        // Prevent closing if we click the wrapper/track, arrows, or pagination dots
        if (
          e.target.closest('.lp-pdp__lightbox-image-wrapper') ||
          e.target.closest('#lp-lightbox-track') ||
          e.target.closest('.lp-pdp__lightbox-arrow') ||
          e.target.closest('.lp-pdp__lightbox-pagination')
        ) {
          return;
        }
        
        closeLightbox();
      });
    }

    if (lightboxPrev) {
      lightboxPrev.addEventListener('click', (e) => {
        e.stopPropagation();
        prevImage();
      });
    }

    if (lightboxNext) {
      lightboxNext.addEventListener('click', (e) => {
        e.stopPropagation();
        nextImage();
      });
    }

    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (!lightbox.classList.contains('lp-pdp__lightbox--active')) return;
      
      if (e.key === 'Escape') {
        closeLightbox();
      } else if (e.key === 'ArrowLeft') {
        prevImage();
      } else if (e.key === 'ArrowRight') {
        nextImage();
      }
    });

    // Touch and Drag (Swipe) navigation
    let touchStartX = 0;
    let touchCurrentX = 0;
    let isDragging = false;
    let trackWidth = 0;

    const setDragPosition = (x) => {
      touchCurrentX = x;
      const diff = touchCurrentX - touchStartX;
      if (lightboxTrack) {
        lightboxTrack.style.transition = 'none';
        
        let newX = -(currentImageIndex * trackWidth) + diff;
        
        if (newX > 0) {
           newX = newX * 0.3; 
        } else if (newX < -(allImages.length - 1) * trackWidth) {
           const overscroll = newX - (-(allImages.length - 1) * trackWidth);
           newX = (-(allImages.length - 1) * trackWidth) + (overscroll * 0.3);
        }

        lightboxTrack.style.transform = `translate3d(${newX}px, 0, 0)`;
      }
    };

    const handleSwipeEnd = () => {
      if (!isDragging) return;
      
      const diff = touchCurrentX - touchStartX;
      const swipeThreshold = 50;

      if (diff < -swipeThreshold && currentImageIndex < allImages.length - 1) {
        currentImageIndex++;
      } else if (diff > swipeThreshold && currentImageIndex > 0) {
        currentImageIndex--;
      }

      if (lightboxTrack) {
        lightboxTrack.style.transition = 'transform 0.3s ease-out';
        lightboxTrack.style.transform = `translate3d(-${currentImageIndex * 100}%, 0, 0)`;
      }
      updateLightboxControls();
      
      isDragging = false;
    };

    if (lightbox) {
      const initDrag = (e, clientX) => {
        if (e.target.closest('.lp-pdp__lightbox-image-wrapper') || e.target.closest('#lp-lightbox-track')) {
          isDragging = true;
          touchStartX = clientX;
          const wrapper = section.querySelector('.lp-pdp__lightbox-image-wrapper');
          trackWidth = wrapper ? wrapper.offsetWidth : window.innerWidth;
          setDragPosition(touchStartX);
        }
      };

      lightbox.addEventListener('touchstart', (e) => {
        initDrag(e, e.changedTouches[0].screenX);
      }, { passive: true });

      lightbox.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        setDragPosition(e.changedTouches[0].screenX);
      }, { passive: true });

      lightbox.addEventListener('touchend', (e) => {
        if (!isDragging) return;
        setDragPosition(e.changedTouches[0].screenX);
        handleSwipeEnd();
      }, { passive: true });

      lightbox.addEventListener('mousedown', (e) => {
        initDrag(e, e.clientX);
      });

      lightbox.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        setDragPosition(e.clientX);
      });

      lightbox.addEventListener('mouseup', (e) => {
        if (!isDragging) return;
        setDragPosition(e.clientX);
        handleSwipeEnd();
      });

      lightbox.addEventListener('mouseleave', (e) => {
        if (!isDragging) return;
        setDragPosition(e.clientX);
        handleSwipeEnd();
      });
    }

    // ============ Initialize Main Image from Selected Variant ============
    function initializeMainImage() {
      const variantSelect = section.querySelector('[name="id"]');
      const variantDataEl = section.querySelector('#lp-variant-data');
      
      if (variantSelect && variantDataEl) {
        try {
          const variantData = JSON.parse(variantDataEl.textContent);
          const selectedVariantId = variantSelect.value;
          const selectedVariant = variantData.find(v => v.id == selectedVariantId);
          const url = getMainImageUrlForVariant(selectedVariant);
          if (url) {
            updateMainImage(url);
          }
        } catch(e) {
          console.error('Error parsing variant data', e);
        }
      }
    }

    // ============ Swiper Initialization ============
    function initializeSwiper() {
      const swiperContainer = section.querySelector('.lp-pdp__swiper');
      
      if (swiperContainer && window.Swiper) {
        const swiper = new Swiper(swiperContainer, {
          loop: false,
          zoom: {
            maxRatio: 3,
            toggle: true,
          },
          pagination: {
            el: section.querySelector('.lp-pdp__swiper-pagination'),
            type: 'bullets',
            clickable: true,
          },
          on: {
            slideChange: () => {
              const activeSlide = swiperContainer.querySelector('.swiper-slide-active img');
              if (activeSlide) {
                updateMainImage(activeSlide.src);
              }
            }
          }
        });
      }
    }

    // ============ Thumbnail Grid Click Handler ============
    function initializeThumbnailGrid() {
      const thumbnailItems = section.querySelectorAll('.lp-pdp__thumbnail-item');
      
      thumbnailItems.forEach((item, index) => {
        item.addEventListener('click', () => {
          const img = item.querySelector('img');
          if (img) {
            // Mark thumbnail as active for visual feedback
            item.classList.add('lp-pdp__thumbnail-item--active');
            thumbnailItems.forEach(t => {
              if (t !== item) t.classList.remove('lp-pdp__thumbnail-item--active');
            });

            // Open lightbox with the clicked image
            initializeAllImages();
            // Since thumbnail grid matches swiper index, use the index directly
            if (index < allImages.length) {
              openLightboxAtIndex(index);
            }
          }
        });
      });
    }

    // ============ Desktop: Main Image Click Opens Lightbox ============
    function initializeMainImageLightbox() {
      const mainImageContainer = section.querySelector('#lp-main-image');
      if (mainImageContainer && window.innerWidth >= 768) {
        mainImageContainer.addEventListener('click', (e) => {
          if (e.target.closest('.ada-video-pause-btn')) return;
          initializeAllImages();
          
          // Find the index of the current main image
          const currentSrc = mainImage.src;
          const getPath = (src) => {
            try { return new URL(src, window.location.origin).pathname; }
            catch(e) { return src.split('?')[0]; }
          };
          const currentPath = getPath(currentSrc);
          
          currentImageIndex = allImages.findIndex(src => getPath(src) === currentPath);
          if (currentImageIndex === -1) currentImageIndex = 0;
          
          openLightboxAtIndex(currentImageIndex);
        });
      }
    }

    // ============ File Upload Logic ============
    function initializeFileUpload() {
      const fileInput = section.querySelector('#lp-engraving-photo');
      const uploadBox = section.querySelector('.lp-pdp__upload-box');
      const uploadPreview = section.querySelector('.lp-pdp__upload-preview');
      const previewImg = section.querySelector('.lp-pdp__upload-preview-img');
      const deleteBtn = section.querySelector('.lp-pdp__upload-delete');
      const variantDataEl = section.querySelector('#lp-variant-data');
      const variantSelect = section.querySelector('[name="id"]');
      let variantData = [];
      
      if(variantDataEl) {
        try { 
          variantData = JSON.parse(variantDataEl.textContent); 
        } catch(e) {
          console.error('Error parsing variant data', e);
        }
      }

      function showPreview(file) {
        const objectUrl = URL.createObjectURL(file);
        previewImg.src = objectUrl;
        previewImg.onload = () => URL.revokeObjectURL(objectUrl);
        uploadBox.setAttribute('hidden', '');
        uploadPreview.removeAttribute('hidden');
        
        // Update button based on current variant
        if (variantSelect && variantData.length > 0) {
          const currentVariantId = variantSelect.value;
          const currentVariant = variantData.find(v => v.id == currentVariantId);
          if (currentVariant) {
            updateButtonForVariant(currentVariant);
          }
        }
      }

      function clearUpload() {
        previewImg.src = '';
        uploadPreview.setAttribute('hidden', '');
        uploadBox.removeAttribute('hidden');
        const dataTransfer = new DataTransfer();
        fileInput.files = dataTransfer.files;
        
        // Update button based on current variant
        if (variantSelect && variantData.length > 0) {
          const currentVariantId = variantSelect.value;
          const currentVariant = variantData.find(v => v.id == currentVariantId);
          if (currentVariant) {
            updateButtonForVariant(currentVariant);
          }
        }
      }

      if (fileInput) {
        fileInput.addEventListener('change', (e) => {
          if (e.target.files && e.target.files.length > 0) {
            showPreview(e.target.files[0]);
          } else {
            clearUpload();
          }
        });
      }

      if (deleteBtn) {
        deleteBtn.addEventListener('click', clearUpload);
      }
    }

    // ============ Form Submission Logic ============
    function initializeFormSubmission() {
      const productForm = section.querySelector('#lp-product-form');
      const submitBtn = section.querySelector('.lp-pdp__submit-btn');
      const submitText = section.querySelector('.lp-pdp__submit-text');

      if (productForm && submitBtn && submitText) {
        productForm.addEventListener('submit', async (e) => {
          e.preventDefault();
          
          // Only proceed if button is not disabled
          if (submitBtn.disabled) return;

          // Add loading state
          submitBtn.classList.add('lp-pdp__submit-btn--loading');
          submitBtn.disabled = true;

          // Show loading dots
          const originalLabel = submitText.textContent;
          submitText.innerHTML = '<span class="lp-pdp__loading-dots"><span class="lp-pdp__loading-dot"></span><span class="lp-pdp__loading-dot"></span><span class="lp-pdp__loading-dot"></span></span>';
          
          try {
            // Get variant ID
            const variantSelect = section.querySelector('[name="id"]');
            const variantId = variantSelect?.value;
            
            if (!variantId) {
              throw new Error('No variant selected');
            }

            // Build cart item object
            const cartItem = {
              id: Number(variantId),
              quantity: 1,
              properties: {}
            };

            // Shoplift price test: carry the test-assignment property Shoplift
            // wrote into the form so its cart transform can reprice the line.
            const slptInput = productForm.querySelector('input[name="properties[_slpt]"]');
            if (slptInput?.value) {
              cartItem.properties['_slpt'] = slptInput.value;
            }

            // Handle file upload - resize + compress, then store base64 in Photo
            const fileInput = section.querySelector('#lp-engraving-photo');
            if (fileInput && fileInput.files && fileInput.files.length > 0) {
              const file = fileInput.files[0];
              const compressedDataUrl = await compressImageFile(file, 1200, 0.8);
              cartItem.properties['Photo'] = compressedDataUrl;
              cartItem.properties['_Photo Filename'] = file.name;
            }

            // Add other text properties
            const notesInput = section.querySelector('#lp-notes');
            if (notesInput && notesInput.value.trim()) {
              cartItem.properties['Note'] = notesInput.value;
            }

            // Use liquidAjaxCart.add if available
            if (typeof window.liquidAjaxCart?.add === 'function') {
              await new Promise((resolve, reject) => {
                window.liquidAjaxCart.add(
                  { items: [cartItem] },
                  {
                    lastCallback: (state) => {
                      if (state?.responseData?.ok) {
                        resolve();
                      } else {
                        reject(new Error('Cart add failed'));
                      }
                    }
                  }
                );
              });
            } else {
              // Fallback to direct fetch
              const root = window.Shopify?.routes?.root || '/';
              const response = await fetch(`${root}cart/add.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(cartItem)
              });

              if (!response.ok) {
                throw new Error('Cart add failed');
              }

              // Update the cart via liquid-ajax-cart if available
              if (typeof window.liquidAjaxCart?.update === 'function') {
                window.liquidAjaxCart.update({}, {});
              }
            }

            // Reset button state and form
            resetButtonState();
            productForm.reset();
            
            // Clear file preview
            const uploadBox = section.querySelector('.lp-pdp__upload-box');
            const uploadPreview = section.querySelector('.lp-pdp__upload-preview');
            if (uploadBox && uploadPreview) {
              uploadPreview.setAttribute('hidden', '');
              uploadBox.removeAttribute('hidden');
            }
          } catch (error) {
            console.error('Error adding to cart:', error);
            submitText.textContent = 'Try again';
            submitBtn.disabled = false;
            submitBtn.classList.remove('lp-pdp__submit-btn--loading');
            
            // Reset text after a delay
            setTimeout(() => {
              submitText.textContent = originalLabel;
            }, 2500);
          }
        });
      }

      const resetButtonState = function () {
        submitBtn.classList.remove('lp-pdp__submit-btn--loading');
        const variantSelect = section.querySelector('[name="id"]');
        const variantDataEl = section.querySelector('#lp-variant-data');
        let variantData = [];
        if (variantDataEl) {
          try {
            variantData = JSON.parse(variantDataEl.textContent);
          } catch (err) {
            variantData = [];
          }
        }
        const currentVariant =
          variantSelect && variantData.length
            ? variantData.find(function (v) {
                return String(v.id) === String(variantSelect.value);
              })
            : null;
        if (currentVariant) {
          updateButtonForVariant(currentVariant);
        } else {
          const fileInput = section.querySelector('#lp-engraving-photo');
          if (fileInput && fileInput.files && fileInput.files.length > 0) {
            submitBtn.disabled = false;
            submitText.textContent = 'Add to Cart';
          } else {
            submitBtn.disabled = true;
            submitBtn.classList.add('lp-pdp__submit-btn--disabled');
            submitText.textContent = 'Image Upload Required';
          }
        }
      };
    }

    // ============ Update Button State for Variant Availability ============
    function updateButtonForVariant(variant) {
      const submitBtn = section.querySelector('#lp-submit-btn');
      const submitText = section.querySelector('.lp-pdp__submit-text');
      const fileInput = section.querySelector('#lp-engraving-photo');
      
      if (!submitBtn || !submitText) return;
      
      const hasFile = fileInput && fileInput.files && fileInput.files.length > 0;
      
      if (variant && !variant.available) {
        // Out of stock - show NOTIFY ME and make clickable, unless the product
        // is tagged `bis-hidden` (no BIS modal rendered) — then it's SOLD OUT.
        const bisHidden = !section.querySelector('#lp-bis-modal');
        submitText.textContent = bisHidden ? 'SOLD OUT' : 'NOTIFY ME';
        submitBtn.disabled = bisHidden;
        submitBtn.classList.toggle('lp-pdp__submit-btn--disabled', bisHidden);
        if (bisHidden) delete submitBtn.dataset.lpBisNotify;
        else submitBtn.dataset.lpBisNotify = 'true';
        submitBtn.type = 'button';
      } else if (hasFile) {
        // In stock with file - show Add to Cart
        submitText.textContent = 'Add to Cart';
        submitBtn.disabled = false;
        submitBtn.classList.remove('lp-pdp__submit-btn--disabled');
        delete submitBtn.dataset.lpBisNotify;
        submitBtn.type = 'submit';
      } else {
        submitText.textContent = 'Image Upload Required';
        submitBtn.disabled = true;
        submitBtn.classList.add('lp-pdp__submit-btn--disabled');
        delete submitBtn.dataset.lpBisNotify;
        submitBtn.type = 'button';
      }
    }

    // ============ Variant Sync Logic ============
    function initializeVariantSync() {
      const variantSelect = section.querySelector('[name="id"]');
      const optionRadios = section.querySelectorAll('.lp-pdp__option-label input[type="radio"]');
      const variantDataEl = section.querySelector('#lp-variant-data');
      let variantData = [];
      
      if(variantDataEl) {
        try { 
          variantData = JSON.parse(variantDataEl.textContent); 
        } catch(e) {
          console.error('Error parsing variant data', e);
        }
      }

      function getVariantOptionValue(variant, optionIndex) {
        if (variant.options && Array.isArray(variant.options)) {
          return variant.options[optionIndex] || null;
        }
        if (optionIndex === 0) return variant.option1 || null;
        if (optionIndex === 1) return variant.option2 || null;
        if (optionIndex === 2) return variant.option3 || null;
        return null;
      }

      // Money formatter — uses active market currency (not a hardcoded $).
      // Prefer section data-currency, then Shopify.currency.active after Markets switch.
      // Forces 'en-US' locale to ensure a dot is used for decimals instead of a comma.
      function formatMoney(cents) {
        const currency =
          section.dataset.currency ||
          window.Shopify?.currency?.active ||
          'USD';
        try {
          return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          }).format(Number(cents) / 100);
        } catch (e) {
          const amount = (Number(cents) / 100).toFixed(2).replace(/\.00$/, '');
          return amount + ' ' + currency;
        }
      }

      // Cents the theme server-rendered into el. Falls back to `fallback` when the
      // element has no seed (other PDP sections render product.price, the lowest).
      function renderedSeed(el, attr, fallback) {
        if (!el) return fallback;
        const raw = el.getAttribute(attr);
        if (raw == null || raw === '') return fallback;
        const n = Number(raw);
        return Number.isFinite(n) ? n : fallback;
      }

      // Per-variant price: update the on-page price block when the variant changes.
      // The sales-final section owns its own price (sale + compare-at + badge) via its
      // own script, so skip it here to avoid clobbering that markup.
      // Writes go through ShopliftPrice so an active Shoplift price test keeps its
      // adjustment instead of being reset to the Shopify price. Sections without
      // data-lp-rendered-price are server-rendered with product.price (the lowest
      // variant price), which seeds the adjustment detection.
      // Stock Alert price rows also carry a strikethrough compare-at price and a
      // percentage-off label; those update here with the selling price.
      function updateMainPrice(variant) {
        if (!variant) return;
        if (section.querySelector('[id^="lp-sf-sale-price-"]')) return;
        const renderedCents = variantData.length ? Math.min(...variantData.map((v) => v.price)) : null;
        section.querySelectorAll('.lp-pdp__price').forEach((el) => {
          window.ShopliftPrice.write(
            el,
            variant.price,
            formatMoney,
            renderedSeed(el, 'data-lp-rendered-price', renderedCents)
          );
        });

        const comparePrice = variant.compare_at_price;
        const onSale = comparePrice != null && Number(comparePrice) > Number(variant.price);

        section.querySelectorAll('.lp-pdp__price-row').forEach((row) => {
          const saleEl = row.querySelector('.lp-pdp__price');
          const compareEl = row.querySelector('.lp-pdp__compare-price');
          const offEl = row.querySelector('.lp-pdp__price-off');
          if (!compareEl && !offEl) return;

          if (compareEl) {
            if (!onSale) {
              compareEl.hidden = true;
            } else {
              window.ShopliftPrice.write(
                compareEl,
                comparePrice,
                formatMoney,
                renderedSeed(compareEl, 'data-lp-rendered-compare', comparePrice)
              );
              compareEl.hidden = false;
            }
          }

          if (!offEl) return;
          if (!onSale) {
            offEl.hidden = true;
            return;
          }

          const shownSale =
            Number(variant.price) +
            window.ShopliftPrice.adjustment(
              saleEl,
              renderedSeed(saleEl, 'data-lp-rendered-price', renderedCents)
            );
          const shownCompare =
            Number(comparePrice) +
            window.ShopliftPrice.adjustment(
              compareEl,
              renderedSeed(compareEl, 'data-lp-rendered-compare', comparePrice)
            );
          const pct =
            shownCompare > 0 ? Math.round(((shownCompare - shownSale) / shownCompare) * 100) : 0;
          if (pct > 0) {
            const prefix = (offEl.getAttribute('data-off-prefix') || '').trim();
            const suffix = (offEl.getAttribute('data-off-suffix') || '').trim();
            offEl.textContent = [prefix, pct + '%', suffix].filter(Boolean).join(' ');
            offEl.hidden = false;
          } else {
            offEl.hidden = true;
          }
        });
      }

      function updateOptionAvailability() {
        if (!variantData.length) return;

        const checkedRadios = Array.from(
          section.querySelectorAll('.lp-pdp__option-label input[type="radio"]:checked')
        );
        const selectedValuesByIndex = [];

        checkedRadios.forEach((radio) => {
          const optionIndex = Number(radio.dataset.index) - 1;
          if (optionIndex >= 0) {
            selectedValuesByIndex[optionIndex] = radio.value;
          }
        });

        optionRadios.forEach((radio) => {
          const optionIndex = Number(radio.dataset.index) - 1;
          const optionValue = radio.value;
          const optionLabel = radio.closest('.lp-pdp__option-label');

          if (!optionLabel || optionIndex < 0) return;

          const matchesSelection = (variant) => {
            if (getVariantOptionValue(variant, optionIndex) !== optionValue) return false;
            return selectedValuesByIndex.every((selectedValue, selectedIndex) => {
              if (!selectedValue || selectedIndex === optionIndex) return true;
              return getVariantOptionValue(variant, selectedIndex) === selectedValue;
            });
          };

          // Does any variant at all use this value with the other selections?
          // If not, the combination doesn't exist (e.g. Gold + Size 10) — hide it.
          const existsAtAll = variantData.some(matchesSelection);
          // Of those, is any in stock? If it exists but is sold out we keep it
          // visible (crossed out) so the NOTIFY ME flow still works.
          const inStock = variantData.some((v) => v.available && matchesSelection(v));

          optionLabel.hidden = !existsAtAll;
          optionLabel.classList.toggle('lp-pdp__option-label--unavailable', existsAtAll && !inStock);
          if (inStock && existsAtAll) {
            radio.removeAttribute('aria-disabled');
          } else {
            radio.setAttribute('aria-disabled', 'true');
          }
          radio.disabled = !existsAtAll;
        });
      }
      
      // Check initial variant on page load
      if (variantSelect && variantData.length > 0) {
        const initialVariantId = variantSelect.value;
        const initialVariant = variantData.find(v => v.id == initialVariantId);
        if (initialVariant) {
          updateButtonForVariant(initialVariant);
          updateMainPrice(initialVariant);
        }
      }
      updateOptionAvailability();

      // When the picked value makes the current combination non-existent (e.g.
      // Gold + Size 10 with no such variant), steer the OTHER option groups to
      // the nearest real variant so the selection always resolves to one that
      // exists — never leaving a stale variant id behind.
      function reconcileToValidVariant(changedRadio) {
        if (!variantData.length) return;
        const changedIndex = Number(changedRadio.dataset.index) - 1;
        if (changedIndex < 0) return;

        const selectedOptions = Array.from(
          section.querySelectorAll('.lp-pdp__option-label input[type="radio"]:checked')
        ).map(r => r.value);

        const alreadyValid = variantData.some(v =>
          selectedOptions.every((val, i) => getVariantOptionValue(v, i) === val)
        );
        if (alreadyValid) return;

        const candidate = variantData.find(v =>
          getVariantOptionValue(v, changedIndex) === changedRadio.value
        );
        if (!candidate) return;

        const groups = Array.from(section.querySelectorAll('.lp-pdp__option-group'));
        groups.forEach((group, index) => {
          if (index === changedIndex) return;
          const target = getVariantOptionValue(candidate, index);
          if (!target) return;
          const targetRadio = group.querySelector(`input[type="radio"][value="${target.replace(/"/g, '\\"')}"]`);
          if (targetRadio && !targetRadio.checked) {
            targetRadio.checked = true;
            const selectedValueEl = section.querySelector(`[data-option-selected="${targetRadio.dataset.index}"]`);
            if (selectedValueEl) selectedValueEl.textContent = targetRadio.value;
          }
        });
      }

      optionRadios.forEach(radio => {
        radio.addEventListener('change', () => {
          // Update label text
          const labelEl = section.querySelector(`[data-option-selected="${radio.dataset.index}"]`);
          if(labelEl) labelEl.textContent = radio.value;
          // Auto-correct impossible combinations before resolving the variant.
          reconcileToValidVariant(radio);
          updateOptionAvailability();

          // Find matching variant
          if (variantData.length > 0) {
            const selectedOptions = Array.from(section.querySelectorAll('.lp-pdp__option-label input[type="radio"]:checked')).map(r => r.value);
            const matchedVariant = variantData.find(v => {
              if (v.options && Array.isArray(v.options)) {
                return v.options.every((opt, i) => opt === selectedOptions[i]);
              }
              const opt1 = selectedOptions[0] || null;
              const opt2 = selectedOptions[1] || null;
              const opt3 = selectedOptions[2] || null;
              return v.option1 === opt1 && v.option2 === opt2 && v.option3 === opt3;
            });

            if (matchedVariant && variantSelect) {
              variantSelect.value = matchedVariant.id;
              
              // Update button for variant availability
              updateButtonForVariant(matchedVariant);

              // Update the on-page price for the selected variant
              updateMainPrice(matchedVariant);

              const newImageSrc = getMainImageUrlForVariant(matchedVariant);

              if (newImageSrc) {
                updateMainImage(newImageSrc);

                let mediaId =
                  featuredMediaMap[matchedVariant.id] != null
                    ? featuredMediaMap[matchedVariant.id]
                    : null;
                if (mediaId == null && matchedVariant.featured_media && matchedVariant.featured_media.id) {
                  mediaId = matchedVariant.featured_media.id;
                }

                let slideIndex = -1;
                if (mediaId != null) {
                  const swiperSlides = section.querySelectorAll('.lp-pdp__swiper-slide img[data-media-id]');
                  swiperSlides.forEach((img, i) => {
                    if (String(img.getAttribute('data-media-id')) === String(mediaId)) {
                      slideIndex = i;
                    }
                  });
                }

                if (slideIndex !== -1) {
                  const swiperContainer = section.querySelector('.lp-pdp__swiper');
                  if (swiperContainer && swiperContainer.swiper) {
                    swiperContainer.swiper.slideTo(slideIndex);
                  }
                }

                variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
              }
            } else if (variantSelect) {
              // No real variant for this combination (should not happen after
              // reconcile, but guard so a stale id can never be submitted).
              variantSelect.value = '';
              updateButtonForVariant(null);
              variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        });
      });
    }

    // ============ Photo Guidelines Modal ============
    const guidelinesTrigger = section.querySelector('#lp-guidelines-trigger');
    const guidelinesModal = section.querySelector('#lp-guidelines-modal');
    const guidelinesClose = section.querySelector('#lp-guidelines-close');
    const guidelinesOverlay = section.querySelector('#lp-guidelines-overlay');

    if (guidelinesTrigger && guidelinesModal) {
      guidelinesTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        guidelinesModal.classList.add('lp-pdp__guidelines-modal--active');
      });
    }

    if (guidelinesClose && guidelinesModal) {
      guidelinesClose.addEventListener('click', () => {
        guidelinesModal.classList.remove('lp-pdp__guidelines-modal--active');
      });
    }

    if (guidelinesOverlay && guidelinesModal) {
      guidelinesOverlay.addEventListener('click', () => {
        guidelinesModal.classList.remove('lp-pdp__guidelines-modal--active');
      });
    }

    // ============ Redo Modal ============
    const redoTrigger = section.querySelector('#lp-redo-info-trigger');
    const redoModal = section.querySelector('#lp-redo-modal');
    const redoClose = section.querySelector('#lp-redo-close');
    const redoOverlay = section.querySelector('#lp-redo-overlay');

    if (redoTrigger && redoModal) {
      redoTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        redoModal.classList.add('lp-pdp__guidelines-modal--active');
      });
    }

    if (redoClose && redoModal) {
      redoClose.addEventListener('click', () => {
        redoModal.classList.remove('lp-pdp__guidelines-modal--active');
      });
    }

    if (redoOverlay && redoModal) {
      redoOverlay.addEventListener('click', () => {
        redoModal.classList.remove('lp-pdp__guidelines-modal--active');
      });
    }

    // ============ Initialize Everything ============
    prefetchMainImagesForSwatches();
    initializeMainImage();
    initializeSwiper();
    initializeThumbnailGrid();
    initializeMainImageLightbox();
    initializeFileUpload();
    initializeFormSubmission();
    initializeVariantSync();
  });
})();
